import { createFileRoute } from '@tanstack/react-router'
import { AnnouncementsScreen } from '@/features/announcements/announcements-screen'

export const Route = createFileRoute('/_authenticated/announcements')({
  component: AnnouncementsScreen,
})
